import React, { useCallback, useState } from 'react';
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

const Step1 = ({ quizz, questions, onSubmit}) => {
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [customQuestion, setCustomQuestion] = useState(quizz.question);
  const [questionError, setQuestionError] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);

  const handleQuestionSelect = (event) => {
    setSelectedQuestion(event.target.value);
    setCustomQuestion(getQuestionLabel(event.target.value));
    setQuestionError(false);
  };

  const handleCustomQuestionChange = (event) => {
    setCustomQuestion(event.target.value);
    setQuestionError(false);
  };

  const handleEditModeToggle = () => {
    setIsEditMode(!isEditMode);
    setCustomQuestion(getQuestionLabel(selectedQuestion));
    setQuestionError(false);
  };

  const getQuestionLabel = useCallback((questionName) => {
    if(!questionName || !questions)
      return ''

    return questions.find(q => q.name === questionName).label
  }, [questions])

  const handleNext = () => {
    if (selectedQuestion || customQuestion) {
      const question = customQuestion || getQuestionLabel(selectedQuestion);
      onSubmit({ question });
    } else {
      setQuestionError(true);
    }
  };

  const isNextDisabled = !selectedQuestion && !customQuestion;

  return (
    <Box sx={{padding:'1rem'}}>
      {isEditMode ? (
          <Box> 
            <Typography variant="h6" gutterBottom>
            Étape 1 : Question du quiz
            </Typography>
            <TextField
              id="custom-question"
              label="Question personnalisée"
              variant="standard"
              margin="normal"
              fullWidth
              value={customQuestion}
              onChange={handleCustomQuestionChange}
              error={questionError && !customQuestion}
              helperText={questionError && !customQuestion ? 'Veuillez saisir une question.' : ''}
            />
        </Box>
      ) : (
        <FormControl fullWidth variant="standard" margin="normal" error={questionError}>
          <InputLabel id="question-select-label">Question</InputLabel>
          <Select
            labelId="question-select-label"
            id="question-select"
            value={selectedQuestion}
            onChange={handleQuestionSelect}
          >
            {questions.map((q) => (
              <MenuItem key={q.name} value={q.name}>
                {q.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {/*<IconButton>
          <EditIcon />
            </IconButton>*/}
        <Box sx={{ flex: 1 }}>
          <Button variant="contained" onClick={handleNext} disabled={isNextDisabled}>Suivant</Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Step1;